import { render, staticRenderFns } from "./CourseCreate.vue?vue&type=template&id=621763d0&scoped=true&"
import script from "./CourseCreate.vue?vue&type=script&lang=ts&"
export * from "./CourseCreate.vue?vue&type=script&lang=ts&"
import style0 from "./CourseCreate.vue?vue&type=style&index=0&id=621763d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621763d0",
  null
  
)

export default component.exports